const stats = [
  { value: "50+", label: "다양한 산업에 \n 특화된 AI 에이전트" },
  { value: "1-Stop", label: "준비된  \nPoC 인프라" },
  { value: "30+", label: "국내 AI 특화 기업들이\n저희 플랫폼을 신뢰하고 있습니다." },
  { value: "24/7", label: "언제나\n함께하는 지원 서비스" },
];

export const StatsSection = () => {
  return (
    <section className="px-5 py-10 lg:px-[100px] lg:py-[100px] bg-transparent">
      <div className="max-w-[1240px] mx-auto flex flex-col items-center lg:flex-row lg:items-center gap-4 lg:gap-[100px]">
        {/* Desktop: image on left, hidden on mobile */}
        <img
          src="/images/bgr-stats.png"
          alt="Industry professionals collaborating"
          className="hidden lg:block w-[415px] h-[521px] object-cover rounded"
        />

        {/* Content column */}
        <div className="w-full lg:w-[725px] lg:shrink-0 flex flex-col gap-12 lg:gap-[48px]">
          {/* Section heading */}
          <div className="flex flex-col items-center lg:items-start gap-2 lg:gap-3">
            <h2 className="text-[44px] leading-[52px] tracking-[-0.0278em] hidden lg:block text-black ">
              업계 리더들이 신뢰하는 플랫폼
            </h2>
            <h2 className="text-[36px] leading-[44px] tracking-[-0.0278em] block lg:hidden text-black text-center">
              업계 리더들이 <br />
              신뢰하는 플랫폼
            </h2>

            <p className="text-body text-black text-center lg:text-left w-[259px] lg:w-full">
              AI로 혁신을 이루고 있는 수많은 기업들과 함께하세요.
            </p>
          </div>

          {/* Stats grid — single column mobile, 2-column wrap desktop */}
          <div className="flex flex-col gap-4 lg:flex-row lg:flex-wrap lg:gap-6">
            {stats.map((stat) => (
              <div
                key={stat.value}
                className="bg-white p-6 lg:p-8 w-full lg:w-[350px] h-[148px] lg:h-[180px] flex flex-col justify-between border border-black/[0.15] rounded"
              >
                <span
                  translate="no"
                  className="text-[36px] leading-[44px] tracking-[-0.0278em] lg:text-display text-[#FD5108] font-bold"
                >
                  {stat.value}
                </span>
                <span
                  translate="no"
                  className="text-h3 text-black leading-[24px] lg:leading-[28px] whitespace-pre-line"
                >
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile: image below stats (visible only on mobile) */}
        <img
          src="/images/bgr-stats.png"
          alt="Industry professionals collaborating"
          className="w-full h-auto object-cover rounded lg:hidden"
        />
      </div>
    </section>
  );
};
